// extracted by mini-css-extract-plugin
export var alertIcon = "_tq-0";